import { LogoWithText } from '@insify/design-system/logo';
import { TrackedAnchor, TrackedDiv } from '@objectiv/tracker-react';
import clsx from 'clsx';

import { LanguageSelect } from '../../LanguageSelect';
import { ProfileInfo } from '../../ProfileInfo/ProfileInfo';

import styles from './styles.module.css';

type Props = {
  className?: string;
  children: React.ReactNode;
};

// TODO: rename to SidebarWithLogo
const NavigationSidebar: React.FC<Props> = ({ children, className }) => (
  <TrackedDiv className={clsx(styles.backdrop, className)} objectiv={{ id: 'sidebar' }}>
    <div className={styles.positionSticky}>
      <TrackedAnchor className={styles.logo} objectiv={{ id: 'logo' }} href='/'>
        <LogoWithText />
      </TrackedAnchor>
      <div className={styles.menu}>{children}</div>
    </div>
    <div className={styles.spacer} />
    <div className={styles.profile}>
      <ProfileInfo />
      <LanguageSelect className={styles.languageSelect} />
    </div>
  </TrackedDiv>
);

export { NavigationSidebar };
